import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';
import { swiperOnResize } from '../utils/swiperOnResize.utils.js';

let officesSwiperWr = document.querySelectorAll('.office-slider');
officesSwiperWr.forEach((el, idx) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slides = el.querySelectorAll('.swiper-slide');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let activeSlideIndex = 0;

    if(slides.length) {
      for (let i = 0; i < slides.length; i++) {
        if(slides[i].classList.contains('active')) {
          activeSlideIndex = i;
        }
      }
    }

    swiperOnResize('(max-width: 1023px)', swiperEl,
      {
        modules: [Autoplay, Navigation],
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 800,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        initialSlide: activeSlideIndex,
        breakpoints: {
          320: {
            slidesPerView: 1,
          },
          500: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
        },
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
      },
    );
  }
});

function updateActiveSlide(index) {
  if (window.innerWidth >= 1024) {
    const slides = document.querySelectorAll('.range-sec__item');
    const listItems = document.querySelectorAll('.range-sec__list-content li');

    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });

    listItems.forEach((li, i) => {
      li.classList.toggle('active', i === index);
    });
  }
}

/*document.addEventListener('DOMContentLoaded', () => {
  updateActiveSlide(0);
});*/

document.querySelectorAll('.range-sec__item').forEach((slide, index) => {
  if(slide.classList.contains('active')) {
    updateActiveSlide(index);
  }
  slide.addEventListener('click', () => {
    updateActiveSlide(index);
  });
});




